// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestForm_requestFormSection__EQ02V {
  padding: 60px 0;
  color: #fff;
}
.RequestForm_mt0__zmpBr{
  margin-top: 0px;
}
.RequestForm_requestFormContainer__xAv\\+t {
  display: flex;
  max-width: 1110px;
  margin: 0 auto;
  gap: 15px;
  position: relative;
  overflow: visible;
}

.RequestForm_requestFormSteps__fTUdj {
  flex: 1 1;
  width: 50%;
}

.RequestForm_requestFormSteps__fTUdj h2 {
  font-size: 32px;
  margin-bottom: 10px;
  color: #fff;
}

.RequestForm_requestFormSubtitle__TH7Aw {
  font-size: 24px;
  margin-bottom: 30px;
  color: #6a85b0;
}

.RequestForm_requestStepsList__lzFc6 {
  /* padding-left: 20px; */
  padding: 0;
  width: 100%;
  text-align: left;
}

.RequestForm_requestStepsList__lzFc6 li {
  padding: 15px;
  padding-left: 25px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  list-style-position: inside;
  color: #ddd;
  text-align: left;
  font-size: var(--font-size-lg);
}

.RequestForm_requestFormWrapper__khUDy {
  width: 50%;
  background-color: var(--color-accent-light);
  padding: 50px;
  border-radius: var(--border-radius-lg);
  box-sizing: border-box;
  position: relative;
  transition: all 0.5s ease-in-out;
  z-index: 1;
}

.RequestForm_formHeader__jhGwd h3 {
  margin-bottom: 30px;
  font-size: var(--font-size-lg);
  text-align: center;
  padding-bottom: 15px;
  text-align: left;
  border-bottom: 1px solid #BCBCCE;
}

.RequestForm_requestForm__C2KB- .RequestForm_formGroup__bRvQ7 {
  margin-bottom: 15px;
  width: 100%;
}

.RequestForm_requestForm__C2KB- input,
.RequestForm_requestForm__C2KB- textarea {
  width: 100%;
  padding: 16px 24px;
  background-color: rgba(0, 0, 0, .12);
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  box-sizing: border-box;
}

.RequestForm_requestForm__C2KB- input::placeholder,
.RequestForm_requestForm__C2KB- textarea::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.RequestForm_checkboxGroup__LZ4IY {
  display: flex;
  align-items: center;
}
.RequestForm_checkboxGroup__LZ4IY span{
  font-size: var(--font-size-base);
  color: #fff;
}
.RequestForm_checkboxGroup__LZ4IY label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.RequestForm_checkboxGroup__LZ4IY input[type="checkbox"] {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  outline: none;
  border: none;
  border-radius: 5px;
}

.RequestForm_checkboxGroup__LZ4IY span {
  font-size: 14px;
}

.RequestForm_requestForm__C2KB- button {
  width: 100%;
  padding: 15px;
  background-color: var(--color-background);
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.RequestForm_requestForm__C2KB- button:hover {
  background-color: #444;
}

.RequestForm_requestForm__C2KB- button:disabled {
  background-color: #555;
  cursor: not-allowed;
}

.RequestForm_submitResult__cFhN5 {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

.RequestForm_success__Yf2bi {
  background-color: rgba(25, 135, 84, 0.2);
  color: #4ade80;
}

.RequestForm_error__PqUyo {
  background-color: rgba(220, 53, 69, 0.2);
  color: #f87171;
}

.RequestForm_fullWidth__29mFN {
  width: 100%;
  box-sizing: border-box;
  display: block;
}

.RequestForm_requestForm__C2KB- textarea[readonly] {
  background-color: rgba(255, 255, 255, 0.05);
  cursor: not-allowed;
  width: 100%;
  box-sizing: border-box;
  resize: none;
}

.RequestForm_highlighted__bG5nB {
  transform: scale(1.03);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  border: 2px solid #4CAF50;
}

@media (max-width: 767px) {
  .RequestForm_requestFormContainer__xAv\\+t {
    flex-direction: column;
  }
  .RequestForm_requestFormSteps__fTUdj {
    width: 100%;
  }
  .RequestForm_requestFormWrapper__khUDy {
    width: 100%;
  }
} 


/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .RequestForm_requestFormSection__EQ02V {
    padding: 10px 0;
    color: #fff;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/EntToEndUI/RequestForm/RequestForm.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iDAAiD;EACjD,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,2CAA2C;EAC3C,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;AACF;;;AAGA,yCAAyC;AACzC;EACE;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".requestFormSection {\n  padding: 60px 0;\n  color: #fff;\n}\n.mt0{\n  margin-top: 0px;\n}\n.requestFormContainer {\n  display: flex;\n  max-width: 1110px;\n  margin: 0 auto;\n  gap: 15px;\n  position: relative;\n  overflow: visible;\n}\n\n.requestFormSteps {\n  flex: 1;\n  width: 50%;\n}\n\n.requestFormSteps h2 {\n  font-size: 32px;\n  margin-bottom: 10px;\n  color: #fff;\n}\n\n.requestFormSubtitle {\n  font-size: 24px;\n  margin-bottom: 30px;\n  color: #6a85b0;\n}\n\n.requestStepsList {\n  /* padding-left: 20px; */\n  padding: 0;\n  width: 100%;\n  text-align: left;\n}\n\n.requestStepsList li {\n  padding: 15px;\n  padding-left: 25px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  list-style-position: inside;\n  color: #ddd;\n  text-align: left;\n  font-size: var(--font-size-lg);\n}\n\n.requestFormWrapper {\n  width: 50%;\n  background-color: var(--color-accent-light);\n  padding: 50px;\n  border-radius: var(--border-radius-lg);\n  box-sizing: border-box;\n  position: relative;\n  transition: all 0.5s ease-in-out;\n  z-index: 1;\n}\n\n.formHeader h3 {\n  margin-bottom: 30px;\n  font-size: var(--font-size-lg);\n  text-align: center;\n  padding-bottom: 15px;\n  text-align: left;\n  border-bottom: 1px solid #BCBCCE;\n}\n\n.requestForm .formGroup {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n.requestForm input,\n.requestForm textarea {\n  width: 100%;\n  padding: 16px 24px;\n  background-color: rgba(0, 0, 0, .12);\n  border: none;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.requestForm input::placeholder,\n.requestForm textarea::placeholder {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.checkboxGroup {\n  display: flex;\n  align-items: center;\n}\n.checkboxGroup span{\n  font-size: var(--font-size-base);\n  color: #fff;\n}\n.checkboxGroup label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.checkboxGroup input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  outline: none;\n  border: none;\n  border-radius: 5px;\n}\n\n.checkboxGroup span {\n  font-size: 14px;\n}\n\n.requestForm button {\n  width: 100%;\n  padding: 15px;\n  background-color: var(--color-background);\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.requestForm button:hover {\n  background-color: #444;\n}\n\n.requestForm button:disabled {\n  background-color: #555;\n  cursor: not-allowed;\n}\n\n.submitResult {\n  margin-top: 15px;\n  padding: 10px;\n  border-radius: 5px;\n  text-align: center;\n}\n\n.success {\n  background-color: rgba(25, 135, 84, 0.2);\n  color: #4ade80;\n}\n\n.error {\n  background-color: rgba(220, 53, 69, 0.2);\n  color: #f87171;\n}\n\n.fullWidth {\n  width: 100%;\n  box-sizing: border-box;\n  display: block;\n}\n\n.requestForm textarea[readonly] {\n  background-color: rgba(255, 255, 255, 0.05);\n  cursor: not-allowed;\n  width: 100%;\n  box-sizing: border-box;\n  resize: none;\n}\n\n.highlighted {\n  transform: scale(1.03);\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  border: 2px solid #4CAF50;\n}\n\n@media (max-width: 767px) {\n  .requestFormContainer {\n    flex-direction: column;\n  }\n  .requestFormSteps {\n    width: 100%;\n  }\n  .requestFormWrapper {\n    width: 100%;\n  }\n} \n\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .requestFormSection {\n    padding: 10px 0;\n    color: #fff;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"requestFormSection": `RequestForm_requestFormSection__EQ02V`,
	"mt0": `RequestForm_mt0__zmpBr`,
	"requestFormContainer": `RequestForm_requestFormContainer__xAv+t`,
	"requestFormSteps": `RequestForm_requestFormSteps__fTUdj`,
	"requestFormSubtitle": `RequestForm_requestFormSubtitle__TH7Aw`,
	"requestStepsList": `RequestForm_requestStepsList__lzFc6`,
	"requestFormWrapper": `RequestForm_requestFormWrapper__khUDy`,
	"formHeader": `RequestForm_formHeader__jhGwd`,
	"requestForm": `RequestForm_requestForm__C2KB-`,
	"formGroup": `RequestForm_formGroup__bRvQ7`,
	"checkboxGroup": `RequestForm_checkboxGroup__LZ4IY`,
	"submitResult": `RequestForm_submitResult__cFhN5`,
	"success": `RequestForm_success__Yf2bi`,
	"error": `RequestForm_error__PqUyo`,
	"fullWidth": `RequestForm_fullWidth__29mFN`,
	"highlighted": `RequestForm_highlighted__bG5nB`
};
export default ___CSS_LOADER_EXPORT___;
